import { useState } from "react";
import styles from "../Dashoard.module.css";
import { getUserData } from "../../../hooks/HelperFunctions";
import moment from "moment-hijri";
import momentEng from "moment";


const StudentInfo = (props) => {
  let userData = getUserData()

  const getTodayDateArabic = () => {
    const hijriMonths = [
      "Muharram", "Safar", "Rabi' al-Awwal", "Rabi' al-Thani", "Jumada al-Awwal", "Jumada al-Thani",
      "Rajab", "Sha'ban", "Ramadan", "Shawwal", "Dhul-Qi'dah", "Dhul-Hijjah"
    ];

    const hijriDate = moment();
    const hijriMonthIndex = hijriDate.iMonth(); // Get the index of the current Hijri month (0-based)
    const hijriFormattedDate = `${hijriMonths[hijriMonthIndex]} ${hijriDate.iDate()}, ${hijriDate.iYear()} AH`;

    return hijriFormattedDate.toUpperCase();
  }

  const getOrdinalSuffix = (day) => {
  if (day >= 11 && day <= 13) {
    return 'th';  // Special case for 11th, 12th, and 13th
  }
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
  };

  const getTodayDate = () => {

  // Get the current Gregorian date (English date)
  const englishDay = momentEng().date();  // Get the day of the month (e.g., 20)
  const englishDate = `${moment().format('dddd, MMMM Do')}${getOrdinalSuffix(englishDay)}`.toUpperCase();

  return englishDate
  }

  return (
    <div  className={styles.studentInfo}>
      <div  className={styles.studentDetailsContainer}>
        <h3>Welcome Back, {userData?.firstName || "N/A"} 👋</h3>
        <div className={styles.studentDtailsDateInfo}>
          <p>{getTodayDateArabic()}</p>
          <span></span>
          <p>{getTodayDate()}</p>
        </div>
      </div>
    </div>
  );
};

export default StudentInfo;
